import { createContext, useContext } from 'react'

export const AdminIdentityContext = createContext(null)
export const useAdminIdentity = () => useContext(AdminIdentityContext)
